import { Injectable } from '@angular/core';
import { forEach, sortBy } from 'lodash-es';
import { BaseApiService } from '../../../shared/services/api';
import { IndustryResponseDto } from 'src/app/shared/dto';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SectorIndustryMapping {

    industryDataObject = {
        'sectors': [],
        'mapping': {},
        'mappingNaicsToName': {},
        'mappingNameToNaics': {},
    };

    constructor(private baseApiService: BaseApiService) { }

    getIndustryData(): Observable<IndustryResponseDto> {
        return this.baseApiService.get<IndustryResponseDto>('service/contactcloud/companies/sectorIndustryMappingV2', { showError: true });
    }

    mappingOfInsdustryData(response) {

        const industryList = response.industries;

        const tmpMappingNaicstoName = {};
        const tmpMappingNametoNaics = {};
        const tmpSectors = [];
        const tmpResult = {};

        forEach(industryList, function (item) {

            tmpMappingNaicstoName[item.naics] = item.industry;

            if (!(item.industry in tmpMappingNametoNaics)) {
                tmpMappingNametoNaics[item.industry] = [];
            }
            tmpMappingNametoNaics[item.industry].push(item.naics);

            // Add sector to sectorlist if not there yet
            if (!tmpSectors.includes(item.sector)) {
                tmpSectors.push(item.sector);
            }

            // not an existing sector? Setup a new entry for it
            if (!(item.sector in tmpResult)) {
                tmpResult[item.sector] = {};
                tmpResult[item.sector].industries = [];
            }

            let hasMatch = false;
            forEach(tmpResult[item.sector].industries, function (industry) {
                if (industry.name === item.industry) {
                    industry.naics.push(item.naics);
                    hasMatch = true;
                }
            });

            if (!hasMatch) {
                // Add industry to sector object
                const industryObject = { name: item.industry, naics: [item.naics] };
                tmpResult[item.sector].industries.push(industryObject);
            }
        });

        this.industryDataObject.sectors = sortBy(tmpSectors);
        this.industryDataObject.mapping = tmpResult;
        this.industryDataObject.mappingNaicsToName = tmpMappingNaicstoName;
        this.industryDataObject.mappingNameToNaics = tmpMappingNametoNaics;

        return this.industryDataObject;
    }
}
